<template>
	<div id="clientRedirections" class="jc-view">
		<JuniperPageHeader :back="'/juniper/clients/edit/' + client.id" :title="client ? client.name : ''" subtitle="Redirections">
			<button class="hu-pill" disabled title="Import will be available soon">
				<font-awesome-icon :icon="['fas', 'file-import']" />
				<span>Import</span>
			</button>
			<button class="hu-pill" @click="addRedirection()" title="Add new redirection">
				<font-awesome-icon :icon="['fas', 'plus']" />
				<span>Add Redirection</span>
			</button>
		</JuniperPageHeader>

		<div class="jrd-intro mt-3">
			<span>Manage old-to-new URL mappings to keep existing links working after migration or content changes.</span>
			<div class="jrd-intro__hint">
				<font-awesome-icon class="text-info me-1" :icon="['fas', 'circle-info']" />
				Run static generation after changes to apply redirects on the website.
			</div>
		</div>

		<!-- Redirections -->
		<div class="ada-card mt-3">
			<div v-if="loading" class="act-empty">
				<span class="spinner-border spinner-border-sm me-2" role="status"></span>Loading…
			</div>
			<div v-else-if="!redirections.length" class="act-empty">
				No redirections are configured for "{{ client.name }}".
			</div>
			<div v-else class="act-table-wrap">
				<table class="act-table">
					<thead>
						<tr>
							<th>From</th>
							<th>To</th>
							<th class="text-end">Actions</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="redirection in redirections" :key="redirection.id">
							<td><span class="jrd-url">{{ redirection.redirect_from }}</span></td>
							<td><span class="jrd-url">{{ redirection.redirect_to }}</span></td>
							<td class="text-end act-actions">
								<button class="act-row-btn" @click="editRedirection(redirection)" title="Edit redirection">
									<font-awesome-icon :icon="['fas', 'pen']" />
								</button>
								<button class="act-row-btn act-row-btn--danger" @click="deleteRedirection(redirection.id)" title="Delete redirection">
									<font-awesome-icon :icon="['fas', 'trash']" />
								</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="modal fade" tabindex="-1" id="redirectionModal">
			<div class="modal-dialog ">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">{{ operation }}</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body" v-if="this.selectedRedirection">
						<div>
							<div class="form-group mb-2">
								<label for="redirectFromUrl">Redirect from URL</label>
								<input type="text" id="redirectFromUrl" v-model="selectedRedirection.redirect_from" class="form-control" />
							</div>
							<div class="form-group mb-2">
								<label for="redirectToUrl">Redirect to URL</label>
								<input type="text" id="redirectToUrl" v-model="selectedRedirection.redirect_to" class="form-control" />
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="ju-modal-btn ju-modal-btn--muted" data-bs-dismiss="modal">Cancel</button>
						<button v-if="operation == 'Creating'" type="button" class="ju-modal-btn ju-modal-btn--primary" @click="storeRedirection()">Create</button>
						<button v-if="operation == 'Updating'" type="button" class="ju-modal-btn ju-modal-btn--primary" @click="updateRedirection()">Update</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import juniperApi from '@/api/juniperApi'
//import restApi from '../../../api/index'
import { Modal } from 'bootstrap'

export default {
	name: 'ClientRedirections',
	data() {
		return {
			loading: false,
			saveLoading: false,
			client: {},
			redirections: [],
			selectedRedirection: null,
			operation: '',
			redirectionModal: null }
	},
	components: {},

	computed: {
		...mapState(['authUser']),
		...mapGetters(['isAuth']) },

	mounted() {
		this.redirectionModal = new Modal('#redirectionModal')
	},

	created() {
		this.getClient()
		this.getRedirections()
	},
	methods: {
		// Get client
		getClient() {
			this.loading = true
			juniperApi
				.get('/clients/' + this.$route.params.id)
				.then(({ data }) => {
					this.client = data
					this.loading = false
				})
				.catch(error => {
					this.loading = false
					console.log(error)
				})
		},

		getRedirections() {
			this.loading = true
			juniperApi
				.get(`/redirections?client_id=${this.$route.params.id}`)
				.then(({ data }) => {
					this.redirections = data
					this.loading = false
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: error.message,
						timer: 6000 })
					console.log(error)
					this.loading = false
				})
		},

		addRedirection() {
			this.operation = 'Creating'
			this.selectedRedirection = {
				redirect_from: '',
				redirect_to: '' }
			this.redirectionModal.show()
		},

		editRedirection(redirection) {
			this.operation = 'Updating'
			this.selectedRedirection = redirection
			this.redirectionModal.show()
		},

		storeRedirection() {
			this.selectedRedirection.client_id = this.$route.params.id
			juniperApi
				.post(`/redirections`, this.selectedRedirection)
				.then(({ data }) => {
					this.redirections.push(data)
					this.$swal.fire({
						icon: 'success',
						title: 'SEO Created',
						timer: 3000 })
					this.redirectionModal.hide()
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: error.message,
						timer: 6000 })
					console.log(error)
				})
		},

		updateRedirection() {
			juniperApi
				.put(`/redirections/${this.selectedRedirection.id}`, this.selectedRedirection)
				.then(() => {
					this.$swal.fire({
						icon: 'success',
						title: 'Redirection Updated',
						timer: 3000 })
					this.redirectionModal.hide()
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: error.message,
						timer: 6000 })
					console.log(error)
				})
		},

		deleteRedirection(id) {
			this.$swal
				.fire({
					title: 'Are you sure want to delete redirection?',
					text: `Deleting a redirect is permanent and you will not be able to recover a deleted redirect.`,
					icon: 'warning',
					position: 'center',
					showCancelButton: true,
					showConfirmButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, delete it!',
					toast: false,
					timer: 0 })
				.then(result => {
					if (result.isConfirmed) {
						console.log(id)
						juniperApi
							.delete(`/redirections/` + id)
							.then(() => {
								this.getRedirections()
								this.$swal.fire({
									icon: 'success',
									title: 'Successfully deleted!',
									timer: 3000 })
							})
							.catch(error => {
								this.$swal.fire({
									icon: 'error',
									title: 'Error deleteing redirection!',
									timer: 6000 })
								console.log(error)
							})
					}
				})
		} } }
</script>

<style scoped>
#clientRedirections {
	padding: 0 0 60px;
	margin-top: 0 !important;
}

.jc-view {
	width: 100%;
}

/* Header action buttons — match the Dashboard/Website quick-action pills */
.hu-pill {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 7px 12px;
	border: 1px solid #e0e1e1;
	border-radius: 999px;
	background: #ffffff;
	color: #64748b;
	font-size: 12px;
	font-weight: 600;
	white-space: nowrap;
	cursor: pointer;
	transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.hu-pill:hover:not(:disabled) {
	background: #f8f9fa;
	border-color: #d1d5db;
	color: #475569;
}

.hu-pill:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}

.hu-pill svg {
	font-size: 12px;
}

.jrd-intro {
	border: 1px solid #e6e8ec;
	border-radius: 12px;
	padding: 12px 14px;
	font-size: 13px;
	color: #4b5563;
	background: transparent;
}

.jrd-intro__hint {
	margin-top: 8px;
	font-size: 12px;
	color: #6b7280;
}

/* Card + compact flat table (settings language, mirrors /activities) */
.ada-card {
	border: 1px solid #e6e8ec;
	border-radius: 12px;
	padding: 1rem 1.1rem;
	background: transparent;
}

.act-empty {
	text-align: center;
	padding: 1.5rem 1rem;
	color: #8a909c;
	font-size: 0.9rem;
}

.act-table-wrap {
	overflow-x: auto;
}

.act-table {
	width: 100%;
	border-collapse: collapse;
	font-size: 13px;
}

.act-table thead th {
	text-align: left;
	font-weight: 600;
	color: #6c757d;
	padding: 4px 10px 8px 0;
	border-bottom: 1px solid #dee2e6;
	white-space: nowrap;
}

.act-table tbody td {
	padding: 8px 10px 8px 0;
	border-bottom: 1px solid #f1f3f5;
	vertical-align: middle;
	color: #2b303b;
}

.act-table tbody tr:last-child td {
	border-bottom: none;
}

.act-table tbody tr:hover td {
	background: #f3f5f9;
}

.jrd-url {
	font-family: 'SF Mono', Menlo, Monaco, Consolas, 'Courier New', monospace;
	font-size: 12px;
	color: #0f172a;
	word-break: break-word;
}

/* Row action icons — plain gray, colour on hover (settings language) */
.act-actions {
	white-space: nowrap;
}

.act-row-btn {
	background: none;
	border: none;
	color: #adb5bd;
	padding: 4px 6px;
	border-radius: 6px;
	cursor: pointer;
	font-size: 13px;
	line-height: 1;
	transition: color 0.15s ease, background 0.15s ease;
}

.act-row-btn + .act-row-btn {
	margin-left: 2px;
}

.act-row-btn:hover {
	color: #2b303b;
	background: #f3f5f9;
}

.act-row-btn--danger:hover {
	color: #dc3545;
	background: #fdecee;
}

/* Modal — settings language */
.modal-content {
	border: 1px solid #e6e8ec;
	border-radius: 12px;
	box-shadow: none;
}

.modal-header,
.modal-footer {
	border-color: #f0f1f4;
}

.modal-title {
	font-size: 1rem;
	font-weight: 600;
	color: #111827;
}

.modal-body .form-control {
	border: 1px solid #e6e8ec;
	border-radius: 8px;
	font-size: 0.9rem;
	padding: 0.45rem 0.7rem;
	box-shadow: none;
}

.modal-body .form-control:focus {
	border-color: #2b6cff;
	box-shadow: 0 0 0 3px rgba(43, 108, 255, 0.15);
}

.form-group label {
	font-size: 0.8rem;
	font-weight: 600;
	color: #374151;
	margin-bottom: 0.25rem;
}

.ju-modal-btn {
	display: inline-flex;
	align-items: center;
	gap: 0.4rem;
	padding: 0.35rem 0.85rem;
	font-size: 0.85rem;
	font-weight: 600;
	border-radius: 8px;
	border: 1px solid #e6e8ec;
	background: transparent;
	color: #111827;
	cursor: pointer;
	transition: background 0.15s ease, border-color 0.15s ease;
}

.ju-modal-btn:hover {
	background: #f3f5f9;
}

.ju-modal-btn--muted {
	color: #6b7280;
}

.ju-modal-btn--primary {
	border-color: #111827;
}
</style>
